<div class="container justify-content-center d-flex flex-column pt-4">
    @if (fetchingEnquete()) {
        <div class="d-flex justify-content-center align-items-center flex-column" style="height: calc(100vh - 56px)">
            <div class="mb-3">Récupération de l'enquête...</div>
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    }
    @if (!fetchingEnquete() && enquete()) {
        <div>
            <div class="row">
                <h3 class="pb-3">Enquête {{ enqueteId() }}</h3>
            </div>
            @if (enqueteCanBeValidated()) {
                <div class="row pb-4">
                    <div class="col-12 py-3 border-top border-bottom border-primary">
                        <div class="row pt-2 pb-4 ps-5">
                            <h5 class="justify-content-center align-items-center">Validation de l'enquête</h5>
                            <h6 class="justify-content-center align-items-center">Souhaitez-vous valider ou refuser l'enquête ?</h6>
                        </div>
                        <form #validateEnqueteFormElement="ngForm" [formGroup]="validateEnqueteForm">
                            @if (enquete().typeEnquete === "GPA") {
                                <div class="row ps-5 pb-3">
                                    <div class="col-12 d-flex">
                                        <div class="form-check form-check-inline">
                                            <input [class.is-invalid]="shouldDisplayInvalid(validateEnqueteForm, validateEnqueteFormElement, 'gestionSav')" [value]="true" class="form-check-input" formControlName="gestionSav" id="withGestionSav" type="radio" />
                                            <label class="form-check-label" for="withGestionSav"> GPA gérée <span class="fw-bolder">avec</span> service SAV dédié </label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input [class.is-invalid]="shouldDisplayInvalid(validateEnqueteForm, validateEnqueteFormElement, 'gestionSav')" [value]="false" class="form-check-input" formControlName="gestionSav" id="withoutGestionSav" type="radio" />
                                            <label class="form-check-label" for="withoutGestionSav"> GPA gérée <span class="fw-bolder">sans</span> service SAV dédié </label>
                                        </div>
                                    </div>
                                    <div class="col-12 d-flex">
                                        @if (shouldDisplayInvalid(validateEnqueteForm, validateEnqueteFormElement, "gestionSav")) {
                                            <div class="invalid-feedback d-block">
                                                <div>Ce champs est obligatoire pour valider l'enquête</div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            @if (delayedLaunch()) {
                                <div class="row ps-5 pb-5">
                                    <div class="col-4">
                                        <label class="form-check-label" for="delayedLaunch"> Date de lancement de l'enquête </label>
                                        <div class="input-group">
                                            <input #d="ngbDatepicker" [displayMonths]="2" [maxDate]="getMaxDate()" [minDate]="getTodayWoTime()" [navigation]="'arrows'" [outsideDays]="'collapsed'" class="form-control border-primary pe-none" formControlName="delayedLaunch" id="delayedLaunch" name="delayedLaunch" ngbDatepicker placeholder="aaaa-mm-jj" readonly />
                                            <button (click)="d.toggle()" class="btn btn-primary bi bi-calendar3" type="button"></button>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div class="row ps-5 pb-3">
                                <div class="col-6 d-flex">
                                    <button (click)="validateEnquete(true)" [disabled]="sendingValidation()" class="btn btn-outline-primary me-5" style="min-width: 10rem" type="submit">
                                        @if (sendingValidation()) {
                                            <span class="spinner-border spinner-border-sm"></span>
                                        }
                                        @if (!sendingValidation()) {
                                            <span>Valider</span>
                                        }
                                    </button>
                                    <button (click)="validateEnquete(false)" [disabled]="sendingValidation()" class="btn btn-outline-primary" style="min-width: 10rem" type="submit">
                                        @if (sendingValidation()) {
                                            <span class="spinner-border spinner-border-sm"></span>
                                        }
                                        @if (!sendingValidation()) {
                                            <span>Refuser</span>
                                        }
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            }
            <div class="card">
                @if (enquete().codeAffaire) {
                    <div class="row">
                        <div class="col-12">
                            <h5 class="card-header p-3 text-start">Affaire n°{{ enquete().codeAffaire }} - {{ enquete().nomAffaire }}</h5>
                        </div>
                    </div>
                }
                <div class="card-body">
                    <div class="row">
                        <div class="col-6 pe-0">
                            <h5 class="card-title pt-2 text-start">Informations Enquête</h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 pe-0">
                            <h6 [ngClass]="lancementIsValid(enquete()?.sat?.lancement) ? 'lg-green' : enquete()?.sat?.lancement === 'Refusé par LG' ? 'lg-red' : ''" class="text-start fw-normal">Statut: {{ getStatutEnqueteLabel() }}</h6>
                        </div>
                    </div>
                    @if (lancementIsValid(enquete()?.sat?.lancement)) {
                        <div class="row">
                            <div class="col-6 pe-0">
                                <h6 class="text-start fw-normal">Date de lancement : {{ enquete()?.sat?.launchDate ? (enquete()?.sat?.launchDate | formatDateFromBack) : "-" }}</h6>
                            </div>
                        </div>
                    }
                    @if (enquete()?.sat?.valideur) {
                        <div class="row">
                            <div class="col-6 pe-0">
                                <h6 class="text-start fw-normal">Modifié par {{ enquete()?.sat?.valideur }}</h6>
                            </div>
                        </div>
                    }
                    <div class="row pt-4">
                        <div class="col-12">
                            <div class="row row-cols-4 gx-5 gy-2 ps-3">
                                <div class="col-3">
                                    <div class="row">Type</div>
                                    <div class="row">
                                        <p class="ps-0 fw-bold">
                                            {{ getTypeEnqueteLabel() }}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="row">Code Chantier</div>
                                    <div class="row">
                                        <p class="ps-0 fw-bold">
                                            {{ enquete().codeChantier ? enquete().codeChantier : "-" }}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="row">Code Entité Principal</div>
                                    <div class="row">
                                        <p class="ps-0 fw-bold">
                                            {{ enquete().codeEntitePrincipale ? enquete().codeEntitePrincipale : "-" }}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="row">Montant Tractation TCE</div>
                                    <div class="row">
                                        <p class="ps-0 fw-bold">
                                            {{ enquete().montantTractationTCE ? enquete().montantTractationTCE : "-" }}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="row">Cumul Origine</div>
                                    <div class="row">
                                        <p class="ps-0 fw-bold">
                                            {{ enquete().cumulOrig ? enquete().cumulOrig : "-" }}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="row">Emails Relais Satisfaction</div>
                                    @if (enquete()?.relaisSAT?.length > 0) {
                                        <div class="row">
                                            @for (relai of enquete().relaisSAT; track relai) {
                                                <p class="ps-0 mb-0 fw-bold">
                                                    {{ relai ? relai : "Email inconnu" }}
                                                </p>
                                            }
                                        </div>
                                    }
                                    @if (!(enquete()?.relaisSAT?.length > 0)) {
                                        <div class="row">
                                            <p class="ps-0 fw-bold">-</p>
                                        </div>
                                    }
                                </div>
                                @if (enquete()?.typeEnquete === "GPA") {
                                    <div class="col-3">
                                        <div class="row">Gestion du SAV</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().gestionSav ? "Avec gestion du SAV dédié" : enquete().gestionSav === false ? "Sans gestion du SAV dédié" : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body pt-4">
                    <div class="row">
                        <div class="col-6 pe-0">
                            <h5 class="card-title pt-2 text-start">Intervenant MOA</h5>
                        </div>
                    </div>
                    <div class="row">
                        @if (!enquete().intervenantMOA) {
                            <div class="col-12">
                                <div class="row ps-3">Inconnu</div>
                            </div>
                        }
                        @if (enquete().intervenantMOA) {
                            <div class="col-12">
                                <div class="row row-cols-4 gx-5 gy-2 ps-3">
                                    <div class="col-3">
                                        <div class="row">Nom</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantMOA.nom ? enquete().intervenantMOA.nom : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Raison Sociale</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantMOA.raisonSociale ? enquete().intervenantMOA.raisonSociale : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Position</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantMOA.position ? enquete().intervenantMOA.position : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Mail</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantMOA.mail ? enquete().intervenantMOA.mail : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Téléphone fixe</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantMOA.telFixe ? enquete().intervenantMOA.telFixe : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Téléphone portable</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantMOA.gsm ? enquete().intervenantMOA.gsm : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div class="card-body pt-4">
                    <div class="row">
                        <div class="col-6 pe-0">
                            <h5 class="card-title pt-2 text-start">Intervenant MOE</h5>
                        </div>
                    </div>
                    <div class="row">
                        @if (!enquete().intervenantMOE) {
                            <div class="col-12">
                                <div class="row ps-3">Inconnu</div>
                            </div>
                        }
                        @if (enquete().intervenantMOE) {
                            <div class="col-12">
                                <div class="row row-cols-4 gx-5 gy-2 ps-3">
                                    <div class="col-3">
                                        <div class="row">Nom</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantMOE.nom ? enquete().intervenantMOE.nom : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Raison Sociale</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantMOE.raisonSociale ? enquete().intervenantMOE.raisonSociale : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Position</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantMOE.position ? enquete().intervenantMOE.position : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Mail</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantMOE.mail ? enquete().intervenantMOE.mail : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Téléphone fixe</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantMOE.telFixe ? enquete().intervenantMOE.telFixe : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Téléphone portable</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantMOE.gsm ? enquete().intervenantMOE.gsm : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div class="card-body pt-4">
                    <div class="row">
                        <div class="col-6 pe-0">
                            <h5 class="card-title pt-2 text-start">Intervenant Autre</h5>
                        </div>
                    </div>
                    <div class="row">
                        @if (!enquete().intervenantAUTRE) {
                            <div class="col-12">
                                <div class="row ps-3">Inconnu</div>
                            </div>
                        }
                        @if (enquete().intervenantAUTRE) {
                            <div class="col-12">
                                <div class="row row-cols-4 gx-5 gy-2 ps-3">
                                    <div class="col-3">
                                        <div class="row">Nom</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantAUTRE.nom ? enquete().intervenantAUTRE.nom : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Raison Sociale</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantAUTRE.raisonSociale ? enquete().intervenantAUTRE.raisonSociale : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Position</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantAUTRE.position ? enquete().intervenantAUTRE.position : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Mail</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantAUTRE.mail ? enquete().intervenantAUTRE.mail : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Téléphone fixe</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantAUTRE.telFixe ? enquete().intervenantAUTRE.telFixe : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="row">Téléphone portable</div>
                                        <div class="row">
                                            <p class="ps-0 fw-bold">
                                                {{ enquete().intervenantAUTRE.gsm ? enquete().intervenantAUTRE.gsm : "-" }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    }
    @if (!fetchingEnquete() && !enquete() && validate()) {
        <div>
            <div class="row">
                <div class="col-12">
                    <div class="d-flex flex-column align-items-center my-5">
                        <h2 class="pb-3">Cette enquête est inconnue</h2>
                        <h4>Veuillez contacter votre key user</h4>
                    </div>
                </div>
            </div>
        </div>
    }
    @if (!fetchingEnquete() && !enquete() && !validate()) {
        <div>
            <div class="row">
                <div class="col-12">
                    <div class="d-flex flex-column align-items-center my-5">
                        <h2 class="pb-3">Bienvenue sur Apisat</h2>
                        <h4>Pour commencer, cliquez sur le lien du mail reçu !</h4>
                    </div>
                </div>
            </div>
        </div>
    }
</div>

<ng-template #refusModal>
    <div class="modal-header">
        <h4 class="modal-title">Refus du lancement de l'enquête : Affaire n°{{ enquete()?.codeAffaire }} - {{ enquete()?.nomAffaire }}</h4>
    </div>
    <div class="modal-body d-flex w-100 justify-content-center align-items-center">
        <div>
            <div class="row pt-1 pb-4 ps-2">
                @if (!sendingValidation()) {
                    <h6 class="justify-content-center align-items-center">Êtes-vous certain de vouloir refuser le lancement de l'enquête ?</h6>
                }
                @if (sendingValidation()) {
                    <h6 class="justify-content-center align-items-center">Refus en cours...</h6>
                }
            </div>
            <div class="row">
                <div class="col-6 d-flex justify-content-center">
                    <button (click)="validateEnquete(false)" [disabled]="sendingValidation()" class="btn btn-primary" style="min-width: 10rem">
                        @if (sendingValidation()) {
                            <span class="spinner-border spinner-border-sm"></span>
                        }
                        @if (!sendingValidation()) {
                            <span>Refuser</span>
                        }
                    </button>
                </div>
                <div class="col-6 d-flex justify-content-center">
                    <button (click)="dismissValidationModal()" [disabled]="sendingValidation()" class="btn btn-outline-secondary" style="min-width: 10rem">
                        @if (sendingValidation()) {
                            <span class="spinner-border spinner-border-sm"></span>
                        }
                        @if (!sendingValidation()) {
                            <span>Annuler</span>
                        }
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
